import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  return {
    generatePreview: (idMessage) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}`
  }
})(process.env.BEEMAILRENDERING_URL)

/**
 * @typedef {Object} WarningItem
 * @property {string} Code
 * @property {string} Message
 *
 * @typedef {Object} GeneratePreviewResponse
 * @property {string} Subject
 * @property {string} Content
 * @property {Array<WarningItem>} Warnings
 *
 *
 * @description Message preview.
 * @param {number} idMessage The message id
 * @param {Object} params
 * @param {number} params.IdRecipient The recipient ID
 * @param {boolean} params.Autosave Autosave flag
 * @param {Array<number>} params.DynamicContentIdList
 * @return {GeneratePreviewResponse}
 */
export const beEmailRenderingApiGeneratePreview = (idMessage, params) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.generatePreview(idMessage),
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify(params)
  }).then(extractApiData)
}
